import { ControlProps, isControl, rankWith } from "@jsonforms/core";
import { useJsonForms, withJsonFormsControlProps } from "@jsonforms/react";
import { ColorBadge } from "@legacy-components/ColorBadge/ColorBadge";

const StatusBadgeRenderer = (props: ControlProps) => {
  const { core } = useJsonForms();

  return (
    <div className="control">
      <label> {props.label}</label>
      <ColorBadge
        width="120px"
        height="2.42em"
        fontSize="12px"
        fontWeight="600px"
        semanticValue={core?.data?.cdSemanticValue}
        text={props.data ?? core?.data?.dsStatus}
      />
    </div>
  );
};

export const statusBadgeRendererTester = rankWith(100, (uischema) => {
  if (!isControl(uischema)) return false;
  return uischema.options?.variant === "statusBadge";
});

export default withJsonFormsControlProps(StatusBadgeRenderer);
